<div class="wrapper">
    <div class="row">
        <div class="col-sm-12 mb-2">
            <div class="govuk-grid-row">
                <div class="govuk-grid-column-two-thirds mobile-breadcrumbs">
                    <!-- <app-breadcrumbs></app-breadcrumbs> -->
                    <br />
                </div>
                <div style="text-align: center;">
                    <h1 class="govuk-heading-l">{{pageTitle}}
                    </h1>
                </div>

            </div>
            <!-- <h1 class="govuk-heading-m" [innerHtml]="dataStore.company?.extra?.summary_page_sub_title"></h1> -->
            <hr /><br />

            <div class="govuk-grid-row">
                <div class="govuk-grid-column">
                    <div class="govuk-body" style="background-color:#fcf8e3; padding: 25px 25px 25px 25px;"
                        [innerHTML]=""></div>
                </div>
            </div>

            <br>

        </div>
    </div>
</div>